<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="width"
      :visible="visible"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      :style="modalStyle"
      @cancel="handleCancel"
      cancelText="关闭">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="handleSubmit">确认提交</a-button>
      </template>
      <a-form :form="form">
        <a-alert type="info" show-icon message="提交流程"
          description="提交后单据将进入多级审批流程，由审批人逐级审批，全部通过后单据自动审核。" />
        <div style="margin-top: 16px; font-size: 14px;">单据编号：{{ billNo }}</div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
  import {mixinDevice} from '@/utils/mixin'
  import { postAction } from '@api/manage'
  export default {
    name: 'WorkflowIframe',
    mixins: [mixinDevice],
    data () {
      return {
        title: "发起流程",
        width: '500px',
        visible: false,
        modalStyle: '',
        billNo: '',
        bigType: 1,
        loading: false,
        form: this.$form.createForm(this),
      }
    },
    methods: {
      show(record, sendWorkflowUrl, billNo, type, height) {
        this.billNo = billNo
        //1-进销存单据 2-财务单据 3-生产单据
        this.bigType = type
        this.visible = true
        this.modalStyle = 'top:20%; height: 55%;'
      },
      handleSubmit() {
        const that = this
        let formData = {}
        formData.bigType = this.bigType
        formData.billNo = this.billNo
        that.loading = true
        postAction('/api/plugin/workflow/workflowTask/add', formData).then((res)=>{
          if(res.code === 200){
            that.$message.success('提交成功！')
            that.close()
            setTimeout(function (){
              that.$emit('ok')
            },1000)
          }else{
            const msg = res.data && res.data.message ? res.data.message : '提交失败'
            that.$message.warning(msg)
          }
        }).finally(() => {
          that.loading = false
        })
      },
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close')
        this.visible = false
        this.modalStyle = ''
      }
    }
  }
</script>

<style scoped>
</style>